export default "/kiban/_next/static/images/blueIcon-d8557966c8d95e543b52c462de9d5117.png";